<template>
    <svg :width="size" :height="size" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <circle fill="#FFF" cx="17.5" cy="16.5" r="15.5" />
            <g fill="#000" fill-rule="nonzero">
                <path d="M21.95 10.678l1.414 1.414L12.05 23.406l-1.414-1.414z" />
                <path d="M23.364 21.991l-1.33 1.33L10.72 12.009l1.33-1.33z" />
            </g>
            <path
                d="M17 34c9.389 0 17-7.611 17-17S26.389 0 17 0 0 7.611 0 17s7.611 17 17 17zm0-2C8.716 32 2 25.284 2 17 2 8.716 8.716 2 17 2c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z"
                fill="#000"
                fill-rule="nonzero"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: 'IconRejectionFilled',
    props: {
        size: {
            type: Number,
            default: 136,
        },
    },
};
</script>
